import { CAT_PROJECTS } from 'App/utils/Collections';

export default {
  category: CAT_PROJECTS,
  filters: [],
  searchBarProp: 'name',
};
